import { Injectable, signal } from '@angular/core';

export type SessionExpiredSource = '401' | 'authentication-error' | 'missing-token';

@Injectable({ providedIn: 'root' })
export class PopupSessionExpiredService {
  readonly expired = signal<SessionExpiredSource | null>(null);

  expire(source: SessionExpiredSource): void {
    if (this.expired() !== null) return;
    this.expired.set(source);
  }
}
